import React from 'react';
import { FormControl, Grid, InputLabel, MenuItem, Select } from '@mui/material';
import { ICampoIndiceProps } from './ICampoIndiceProps';

export const CampoSelect: React.FC<ICampoIndiceProps> = ({ indice, valor, disabled, onChange, comOpcaoNenhum, valorOpcaoNenhum = 'nenhum' }) => {
    return (
        <Grid item xs={12} sm={12} md={6} key={indice.idIndice}>
            <FormControl key={'FormControl-' + indice.idIndice} fullWidth>
                <InputLabel key={'InputLabel-' + indice.idIndice}>{indice.nomeIndice}</InputLabel>
                <Select
                    key={'Select-' + indice.idIndice}
                    label={indice.nomeIndice}
                    disabled={disabled}
                    value={valor ?? ''}
                    onChange={(event) => onChange(event.target.value)}
                >
                    {comOpcaoNenhum && (
                        <MenuItem key={'nenhum-' + indice.idIndice} value={valorOpcaoNenhum}>
                            <i> Nenhum </i>
                        </MenuItem>
                    )}
                    {!!indice.opcoes &&
                        indice.opcoes.split('^ ').map((op) => (
                            <MenuItem key={op + '-' + indice.idIndice} value={op}>
                                {op}
                            </MenuItem>
                        ))}
                </Select>
            </FormControl>
        </Grid>
    );
};
